// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"fb488853","130":"b0806f06","160":"de7c07d9","207":"94926fde","227":"17dbe3a5","308":"d9f12a34","312":"57bbfa76","422":"a8f87740","450":"22a76b0e","478":"663f9792","491":"2ad95903","523":"158aa5e0","667":"f871a8d9","730":"d869678a","839":"d32a5fde","987":"c575b8c5"}[chunkId] + ".chunk.js";
};